const KEYWORDS = [
  'AWS Pricing Calculator',
  'Google Cloud Pricing Calculator',
  'Azure Storage Cost Calculator',
  'GCP Cost Estimator',
  'Azure Virtual Desktop Cost Calculator',
  'AWS EC2 instances pricing',
  'Lambda AWS cost calculator',
  'BigQuery query cost calculator',
  'AWS data transfer pricing',
  'Azure Cold Storage pricing',
]

function SeoChips() {
  return (
    <div className="flex flex-wrap gap-2">
      {KEYWORDS.map(k => (
        <span
          key={k}
          className="text-[11px] font-mono text-slate-400 bg-[#0E1525] border border-[#1F2A44] hover:border-cyan-500/30 hover:text-cyan-300 transition-colors rounded-full px-3 py-1.5 cursor-default"
        >
          {k}
        </span>
      ))}
    </div>
  )
}

export default SeoChips
